<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 8/12/2022
  -->

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwBaseButton",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		labelAnalytics: String,
	},

	methods:{
		onClickInternal(...args){
			this.trackClick()
			console.log("clickDebug onClickInternal: this.$attrs = ", this.$attrs, ", this = ", this)
			if(this.$attrs.onClick){
				this.$attrs.onClick(...args)
			}
		},

		trackClick(){
			// if(this.analyticsProps){
			let titleText = this.$el.innerText || "Button"//this.$slots.default && this.$slots.default[0] ? this.$slots.default[0].text : "Button"
			// console.log("this.$slots = ", this.$slots)
			let buttonTitle = titleText.trim()
			let eventName = `Button clicked`
			this.$analyticManager.trackEvent(eventName, {...this.analyticsPropsMethod(), title: buttonTitle})
			// }
		}
	},

	computed: {
		//this should be attrsComputed
		listenersComputed() {
			// delete this.$attrs.onClick
			let listeners = {
				...this.$attrs,
				onClick: this.onClickInternal
			}
			// console.log("listenersComputed: listeners = ", listeners, ", attrs = ", this.$attrs)
			// listeners.onClick()
			return listeners
		}
	},
}
</script>

<style lang="scss">

</style>
